<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form ref="searchForm">
					<c-form-item v-if="systemConfig.pt_mode == 2 && systemConfig.operation_mode_enabled == 'ON'" type="radio" label="运营模式" name="operation_mode" :options="operationMode"></c-form-item>
					<c-form-item v-if="systemConfig.pt_mode == 2" type="hidden" name="stationed_id"></c-form-item>
					<c-form-item v-if="systemConfig.pt_mode == 2" type="input" label="所属商家" name="company_name" readonly @click="$refs.stationedSelector.open()" clear-button @clear="$refs.searchForm.set({stationed_id: '', company_name: ''})"></c-form-item>
					<c-form-item type="select" label="商品类目" name="product_type_id" options="PRODUCT_CLASSIFY"></c-form-item>
					<c-form-item type="input" label="货号" name="product_itemnumber"></c-form-item>
					<c-form-item type="input" label="商品名称" name="product_name"></c-form-item>
					<c-form-item type="datetime" label="上下架时间" start-name="sell_state_start_date" end-name="sell_state_end_date"></c-form-item>
					<c-form-item type="checkbox" name="state" :options="productState"></c-form-item>
				</c-form>
			</m-search>
			
			<m-operate>
				<c-button power="b_product_audit_list_audit" color="black" hollow @click="batchAudit()">批量审核</c-button>
			</m-operate>
			
			<c-table ref="table" >
				<c-table-column
					type="selector"
				></c-table-column>
				
				<c-table-column
					label="状态"
					name="state"
					width="60"
				>
					<template v-slot="{data}">
						<span v-if="data.state == 0" style="color:red">{{productStateName[data.state]}}</span>
						<span v-if="data.state == 1" style="color:#999999">{{productStateName[data.state]}}</span>
						<span v-if="data.state == 2" style="color:green">{{productStateName[data.state]}}</span>
						<span v-if="data.state == 3" style="color:blue">{{productStateName[data.state]}}</span>
						<span v-if="data.state == 4" style="color:red">{{productStateName[data.state]}}</span>
					</template>
				</c-table-column>
				
				<!-- <c-table-column
					label="货号"
					name="product_itemnumber"
				></c-table-column> -->
				
				<c-table-column
					label="运营模式"
					name="operation_mode"
					width="80"
					v-if="systemConfig.pt_mode == 2 && systemConfig.operation_mode_enabled == 'ON'"
				>
					<template v-slot="{data}">
						{{productModeName[data.operation_mode]}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="商家角色"
					name="stationed_auth_name"
					width="110"
					v-if="systemConfig.pt_mode == 2 && systemConfig.stationed_authname_enabled == 'ON'" 
				>
				</c-table-column>
				
				<c-table-column
					label="商家名称"
					name="stationed_name"
					width="150"
					v-if="systemConfig.pt_mode == 2" 
				></c-table-column>
				
				<c-table-column
					label="商品信息"
					name="product_name"
					width="350"
				>
					<template v-slot="{data}">
						<product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name"></product-info>
						<product-info v-else :image="data.product_img_url" :name="data.product_name"></product-info>
					</template>
				</c-table-column>
				
				<c-table-column
					label="定制"
					width="60"
					name="is_custom"
					v-if="systemConfig.product_custom == 'ON'"
				>
					<template #default="{data}">
						<span v-if="data.is_custom == 1" style="color:blue">支持</span>
						<span v-else style="color:#999">不支持</span>
					</template>
				</c-table-column>
				
				<!-- <c-table-column
					label="商品卖点"
					name="product_subtitle"
					width="100"
				></c-table-column> -->
				
				<c-table-column
					label="所属类目"
					name="product_type_full_name"
					width="200"
				></c-table-column>
				
				<c-table-column
					label="供应价(元)"
					name="product_cost_price"
					width="140"
				>
					<template v-slot="{data}">
						￥{{data.product_cost_price}}
					</template>
				</c-table-column>

				<c-table-column
					label="售价(元)"
					name="product_price"
					width="140"
				>
					<template v-slot="{data}">
            ￥{{data.product_price}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="创建时间"
					name="create_date"
					width="140"
				></c-table-column>
				
				<c-table-column
					label="上下架时间"
					name="sell_state_date"
					width="140"
				></c-table-column>
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="220"
				>
					<template v-slot="{data}">
						<c-table-button power="b_product_edit" v-if="data.operation_mode == 1" @click="navigateTo(`/product_edit/${data.product_id}`)">编辑</c-table-button>
						<c-table-button power="b_product_edit" v-if="data.operation_mode == 2" @click="navigateTo(`/product_edit/${data.product_id}`)">查看</c-table-button>
            <c-table-button power="b_product_audit_list_audit" v-if="data.state != 3 && data.state != 4 && data.platform_profit_model == 2" @click="auditHandle('edit', data)">调整加价</c-table-button>
						<c-table-button power="b_product_audit_list_audit" v-if="data.state == 3" @click="auditHandle('pass', data)">审核通过</c-table-button>
						<c-table-button power="b_product_audit_list_audit" v-if="data.state == 3" @click="auditHandle('reject', data)">审核驳回</c-table-button>
						<c-table-button power="b_product_stock"  v-if="data.operation_mode == 1" @click="setStock(data)">库存设置</c-table-button>
                        <c-table-button power="b_product_edit" v-if="data.operation_mode == 1 && (data.state == 0 || data.state == 1)" @click="delHandle(data)">删除</c-table-button>
                        <c-table-button power="b_product_tag_set" v-if="data.operation_mode == 1" @click="setTags(0,data)">标签设置</c-table-button>

          </template>
				</c-table-column>
			</c-table>
		</module>

		<c-dialog ref="productAuditSupplier" :title="optionType==1?'商品审核':'调整加价'" width="1100" height="500" @resolve="auditProduct">
      <module title="规格信息">
        <c-table ref="auditTableSupplier" height="auto" :paging="false">
          <c-table-column
            label="规格名称"
            name="product_sku_spec"
            width="300"
          ></c-table-column>

          <c-table-column
            label="供应价"
            name="product_price_cost"
            width="150"
          >
            <template v-slot="{data}">
              ￥{{data.product_price_cost}}
            </template>
          </c-table-column>

          <c-table-column
            label="当前售价"
            name="product_price"
            width="150"
          >
            <template v-slot="{data}">
              ￥{{data.product_price}}
            </template>
          </c-table-column>

          <c-table-column
            label="加价金额"
            width="150"
          >
			<template slot="head">
				<div class="flex-center-cross">
					<span>加价金额</span>
					<a style="margin-left: 10px;" @click="$refs.batchPriceDialog.open()"><i class="tf tf-edit"></i></a>
				</div>
			</template>
            <template v-slot="{data}">
              <c-input v-model="data.product_raise_price" type="number" :limit="[0, 9999]" decimal="2"></c-input>
            </template>
          </c-table-column>

          <c-table-column
            label="调整后售价"
            name="product_sku_stock"
            width="150"
          >
            <template v-slot="{data}">
              ￥{{(parseFloat(data.product_price_cost) + (parseFloat(data.product_raise_price) || 0)).toFixed(2)}}
            </template>
          </c-table-column>
        </c-table>
      </module>
      <module title="定制信息" v-show="isCustom == 1">
        <c-table ref="customTable" height="auto" :paging="false">
          <c-table-column
              label="定制项"
              name="item_name"
              width="200"
          >
            <template v-slot="{data}">
              {{data.item_name}}{{data.param_value ? '【' + data.param_value + '】' : ''}}
            </template>
          </c-table-column>

          <c-table-column
              label="定制位置"
              name="position_name"
              width="100"
          >
            <template v-slot="{data}">
              <div v-if="data.position_name" class="flex-center-cross">
                <c-image :src="data.position_image_url" preview size="30" style="margin-right: 10px;"></c-image>
                <span>{{data.position_name}}</span>
              </div>
            </template>
          </c-table-column>

          <c-table-column
              label="工艺名称"
              name="tech_name"
              width="100"
          ></c-table-column>

          <c-table-column
              label="起定量"
              name="min_custom_count"
              width="60"
          ></c-table-column>

          <c-table-column
              label="商家定制价"
              name="product_price_cost"
              width="80"
          >
            <template v-slot="{data}">
              ￥{{data.product_price_cost}}
            </template>
          </c-table-column>

          <c-table-column
              label="当前定制价"
              name="product_price"
              width="80"
          >
            <template v-slot="{data}">
              ￥{{data.product_price}}
            </template>
          </c-table-column>

          <c-table-column
              label="平台加价金额"
              width="100"
          >
			<template slot="head">
				<div class="flex-center-cross">
					<span>加价金额</span>
					<a style="margin-left: 10px;" @click="$refs.batchCustomPriceDialog.open()"><i class="tf tf-edit"></i></a>
				</div>
			</template>
            <template v-slot="{data}">
              <c-input v-model="data.custom_raise_price" type="number" :limit="[0, 9999]" decimal="2"></c-input>
            </template>
          </c-table-column>

          <c-table-column
              label="调整后定制价"
              name="product_sku_stock"
              width="100"
          >
            <template v-slot="{data}">
              ￥{{(parseFloat(data.product_price_cost) + (parseFloat(data.custom_raise_price) || 0)).toFixed(2)}}
            </template>
          </c-table-column>
        </c-table>
      </module>
		</c-dialog>
		<c-dialog ref="productAuditMerchant" title="商品审核" width="750" @resolve="auditProduct">
      <c-table ref="auditTableMerchant" height="500" :paging="false">
        <c-table-column
            label="规格名称"
            name="product_sku_spec"
            width="300"
        ></c-table-column>

        <c-table-column
            label="当前售价"
            name="product_price"
            width="150"
        ></c-table-column>
      </c-table>
		</c-dialog>

    <c-dialog ref="auditRejectDialog" title="商品审核" width="750" height="300" @resolve="auditProduct">
      <c-form title="驳回原因" ref="form">
        <c-form-item type="textarea" name="reject_reason" placeholder="请输入驳回原因" required></c-form-item>
      </c-form>
    </c-dialog>

    <c-dialog ref="stockEdit" title="库存设置" width="750" @resolve="setStockHandle">
			<c-table ref="stockTable" height="500" :paging="false">
				<c-table-column
					label="规格名称"
					name="product_sku_spec"
					width="300"
				></c-table-column>

				<c-table-column
					label="当前库存"
					name="product_sku_stock"
					width="150"
				></c-table-column>

				<c-table-column
					label="增减库存"
					width="150"
				>
					<template v-slot="{data}">
						<c-input v-model="data.revise_stock" type="number" :limit="[-data.product_sku_stock, 9999]"></c-input>
					</template>
				</c-table-column>

				<c-table-column
					label="调整后库存"
					name="product_sku_stock"
					width="150"
				>
					<template v-slot="{data}">
						{{parseInt(data.product_sku_stock) + (parseInt(data.revise_stock) || 0)}}
					</template>
				</c-table-column>
			</c-table>
		</c-dialog>

        <c-dialog ref="tagEdit" title="标签设置" width="750" height="400" @resolve="setTagHandle">
            <div class="tag-list">
				<c-checkbox-group v-model="currentProductTag">
					<c-checkbox v-for="(item, i) in productTagList" :key="i" :value="item.id" class="tag-item">
						<img v-if="item.tag_img" class="tag-img" :src="item.tag_img" alt="">
						<span v-else class="tag-text" :style="{'border-color': item.tag_color, 'color': item.tag_color}">{{item.tag_name}}</span>
					</c-checkbox>
				</c-checkbox-group>
            </div>
        </c-dialog>
		<!--单商品多SKU-->
        <c-dialog ref="batchPriceDialog" title="批量加价" width="400" height="140" @resolve="batchSetPrice">
            <c-form ref="batchPriceForm">
				<c-form-item type="number" label="加价金额" :limit="[0,999]" name="value" decimal="2"></c-form-item>
			</c-form>
        </c-dialog>

		<!--单商品多SKU-->
        <c-dialog ref="batchCustomPriceDialog" title="批量加价" width="400" height="140" @resolve="batchSetCustomPrice">
            <c-form ref="batchCustomPriceForm">
				<c-form-item type="number" label="加价金额" :limit="[0,999]" name="value" decimal="2"></c-form-item>
			</c-form>
        </c-dialog>

		<!--多商品-->
		<c-dialog ref="batchAuditDialog" title="批量审核" width="500" @resolve="batchAuditHandle">
            <c-form ref="batchAuditForm">
				<c-form-item type="radio" label="审核结果" name="state" v-model="auditState" :options="auditStateOptions" required></c-form-item>
				<c-form-item type="number" label="商品加价比例" v-show="auditState == 1" :limit="[0,999]" name="add_product_ratio" decimal="0" input-unit="%" word="针对平台盈利模式为加价销售的商品生效" required></c-form-item>
				<c-form-item type="number" label="定制加价金额(单项)" v-show="auditState == 1" :limit="[0,999]" name="add_custom_money" decimal="2" input-unit="元" word="针对平台盈利模式为加价销售的商品生效" required></c-form-item>
				<c-form-item type="textarea" label="驳回原因" v-show="auditState == 2" name="reject_reason" placeholder="请输入驳回原因" required></c-form-item>
			</c-form>
        </c-dialog>
		
		<stationed-selector ref="stationedSelector" @resolve="selectStationed"></stationed-selector>
    </page>
</template>

<script>
	import productInfo from '@/components/public/product_info.vue'
	import stationedSelector from '@/components/service/stationed_selector.vue'  // 商家库
	import {mapState} from 'vuex'
	
	export default {
		name: 'm_product_audit_list',
		
		components: {
			productInfo,
			stationedSelector
		},
		
		data() {
			return {
				productState: [{
					name: '草稿',
					value: 0
				}, {
					name: '待审核',
					value: 3
				}, {
					name: '上架',
					value: 2
				}, {
					name: '下架',
					value: 1
				}, {
					name: '已驳回',
					value: 4
				}],
				productModeName: {
					1: '平台自营',
					2: '商家自营'
				},
				operationMode: [{
						name: '平台自营',
						value: 1
					},{
						name: '商家运营',
						value: 2
					}
				],
				auditStateOptions: [{
						name: '审核通过',
						value: 1
					},{
						name: '审核驳回',
						value: 2
					}
				],
				auditState: 1,
				
				productClassify: [
					[], [], []
				],
				currentClassify: [],
				classifySearch: [],
				currentClassifyId: '',
                flushImportHisTableTimer: null,
				productTagList: [],
				currentProductTag: [],
				auditType: '',
				isCustom: 0,
				optionType: 1
			}
		},
		
		computed: {
			...mapState(['systemConfig']),
			...mapState({
				productStateName: state => state.dict.productState
			})
		},
		
		mounted() {
			this.$refs.search.search();
			
			this.$bus.$on('productList.update', page => {
				this.$refs.table.update(page);
			});
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/product/list',
					data: Object.assign(data, {audit_product: 1})
				});
			},
			
			selectClassify() {
				if (!this.productClassify[0].length) {
					this.getClassify(0, 0);
				}
				this.$refs.classifySelector.open();
			},
			
			classifyHandle(item, level) {
				this.currentClassifyId = item.id;
				this.$set(this.currentClassify, level, item);
				if (level < 2) {
					this.getClassify(level+1, !item.is_parent);
				}
			},
			
			getClassify(level, empty) {
				new Promise(resolve => {
					if (empty) {
						resolve([]);
					} else {
						this.request({
							url: '/product_type/common_list',
							data: {
								type_name: this.classifySearch[level],
								parent_id: level ? this.currentClassify[level-1].id : 0
							},
							success: data => {
								if (!data) {
									this.$message({
										text: '未找到类目'
									});
									return;
								}
								
								resolve(data);
							}
						});
					}
				}).then(data => {
					this.$set(this.productClassify, level, data);
					for (let i=level; i<3; i++) {
						i > level && this.$set(this.productClassify, i, []);
						this.$set(this.currentClassify, i, undefined);
					}
					this.currentClassifyId = level ? this.currentClassify[level-1].id : '';
				});
				this.$set(this.classifySearch, level, '');
			},
			
			createProduct(stop) {
				if (!this.currentClassifyId) {
					stop();
					this.$message({
						text: '请选择类目'
					});
					return;
				}
				
				var name = [];
				this.currentClassify.forEach(item => {
					item && name.push(item.type_name);
				});
				this.navigateTo({
					path: '/product_apply',
					query: {
						classify: this.currentClassifyId,
						classifyName: name.join(',')
					}
				});
			},

      auditHandle(type, item) {
        this.auditType = type;
        this.isCustom = item.is_custom;
        this._platformProfitModel = item.platform_profit_model;
        this._auditProductId = item.product_id;
		if(type == 'edit'){
			this.optionType = 2;
		}else{
			this.optionType = 1;
		}
        if(type == 'pass' || type == 'edit') {
          if(item.platform_profit_model == 1) {
            this.$refs.productAuditMerchant.open();
            this.$refs.auditTableMerchant.load({
              url: '/product/get_sku',
              data: {
                product_id: item.product_id
              },
              dataFormatter: data => {
                data.forEach(item => {
                  item.revise_stock = '';
                });
                return data;
              }
            });
          }else{
            this.$refs.productAuditSupplier.open();
            this.$refs.auditTableSupplier.load({
              url: '/product/get_sku',
              data: {
                product_id: item.product_id
              }
            });

            if(this.isCustom == 1) {
              this.$refs.customTable.load({
                url: '/product/custom/info',
                data: {
                  product_id: item.product_id
                },
                dataFormatter: data => {
                  var tableData = [];
                  data.forEach(item => {
                    if(item.list.length != 0) {
                      tableData = tableData.concat(item.list);
                    }
                  });
                  return tableData;
                }
              });
            }
          }
        }else{
          this.$refs.auditRejectDialog.open();
        }
			},

			delHandle(params) {
				this.$confirm({
					text: '确定要删除商品【'+params.product_name+'】吗？',
					resolve: () => {
						this.request({
							url: '/product/del',
							data: {
								product_id: params.product_id
							},
							loading: true,
							success: data => {
								this.$message({
									text: '商品删除成功！',
									icon: 'success'
								});
								this.$refs.table.update();
							}
						});
					}
				});
			},

			setStock(item) {
				this._setStockId = item.product_id;
				this.$refs.stockEdit.open();
				this.$refs.stockTable.load({
					url: '/product/get_sku',
					data: {
						product_id: item.product_id
					},
					dataFormatter: data => {
						data.forEach(item => {
							item.revise_stock = '';
						});
						return data;
					}
				});
			},
			
			setStockHandle(stop) {
				stop();
				this.request({
					url: '/product/set_sku_stock',
					data: {
						product_id: this._setStockId,
						product_sku_stock_list: Array.from(this.$refs.stockTable.getRow(), item => {
							return {
								product_sku: item.data.product_sku,
								product_total_count: parseInt(item.data.revise_stock) || 0
							}
						})
					},
					loading: true,
					success: data => {
						this.$message({
							text: '库存设置成功'
						});
						this.$refs.stockEdit.close();
					}
				});
			},

            setTags(batch,item) {
                this.tagProductIds = [];
                if(batch == 1){
                    var list = this.$refs.table.getRow('selected');
                    if (!list.length) {
                        this.$message({
                            text: '请选择要操作的商品'
                        });
                        return;
                    }
                    this.tagProductIds = Array.from(list,item=>{
                        return item.data.product_id;
                    })
                }else{
                    this.tagProductIds.push(item.product_id);
                }
                this.request({
                    url: '/product/get_product_tags',
                    data: {
                        is_batch: batch,
                        product_id: batch == 0 ? item.product_id : null
                    },
                    loading: true,
                    success: data => {
						this.productTagList = data.all_tags;
						this.$nextTick(() => {
							this.currentProductTag = Array.from(data.product_tags, item => {
								return item.tag_id;
							});
						});
                        this.$refs.tagEdit.open();
                    }
                });

            },

            setTagHandle(stop) {
                stop();
                this.request({
                    url: '/product/set_product_tags',
                    data: {
                        product_ids: this.tagProductIds,
                        tag_ids: this.currentProductTag
                    },
                    loading: true,
                    success: data => {
                        this.$message({
                            text: '标签设置成功'
                        });
                        this.$refs.tagEdit.close();
                    }
                });
            },

            flushImportTable(){
                this.$refs.importHistoryListTable.load({
                    url: '/import_job/list',
                    dataFormatter: data => {
                        return data;
                    }
                });
            },


            viewImportHistory(){
                this.$refs.importHistoryListEdit.open();
                this.loadFlushHisTableTimer();
                this.$refs.importHistoryListTable.load({
                    url: '/import_job/list',
                    dataFormatter: data => {
                        return data;
                    }
                });
            },

            loadFlushHisTableTimer(){
                this.flushImportHisTableTimer = setInterval(()=>{
                    this.$refs.importHistoryListTable.load({
                        url: '/import_job/list',
                        dataFormatter: data => {
                            return data;
                        }
                    });
                },10000)
            },

            closeImportHistoryListEdit(){
                clearInterval(this.flushImportHisTableTimer);
                this.flushImportHisTableTimer =null;
            },

            importProduct() {
                this.$confirm({
                    title: '导入提示',
                    buttonName: '开始导入',  // 确定按钮文字
	                text: '请使用标准模板进行导入商品 <a href="https://cdn.tkvip.com/app_static/base/%E5%95%86%E5%93%81%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx" target="_blank" style="color:dodgerblue;">模板下载</a>',
                    resolve: () => {
                        this.uploadFile({
                            message: false,
                            success: data => {
                                this.request({
                                    url: '/import_job/add',
                                    data: {
                                        filePath: data.filePath
                                    },
                                    loading: true,
                                    timeout: false,
                                    success: (data, message) => {
                                        this.$message({
                                            text: "导入任务提交成功,导入结果稍后查询",
                                            icon: 'success'
                                        });
                                        this.$refs.importHistoryListTable.update();
                                    }
                                });
                            }
                        });
                    }
                })
            },
			selectStationed(data) {
				this.$refs.searchForm.set({
					stationed_id: data[0].id,
					company_name: data[0].company_name
				});
			},
			
			batchSetPrice() {
				let n = parseFloat(this.$refs.batchPriceForm.serialize().value);
				if (n == n) {
					this.$refs.auditTableSupplier.getRow().forEach(item => {
						item.data.product_raise_price = n;
					})
				}
				this.$refs.batchPriceForm.clear();
			},
			
			batchSetCustomPrice() {
				let n = parseFloat(this.$refs.batchCustomPriceForm.serialize().value);
				if (n == n) {
					this.$refs.customTable.getRow().forEach(item => {
						item.data.custom_raise_price = n;
					})
				}
				this.$refs.batchCustomPriceForm.clear();
			},

			auditProduct(stop) {
				stop();
				if(this.auditType == 'reject') {
					var rule = {
						reject_reason: '请填写驳回原因'
					};
					this.$refs.form.submit({
						url: '/product/audit',
						rule: rule,
						dataFormatter: data => {
							return Object.assign(data, {
								product_id: this._auditProductId,
								audit_type: 2
							});
						},
						success: (data, res) => {
							this.$message({
								text: '审核成功'
							});
							this.$refs.table.update();
							this.$refs.auditRejectDialog.close();
						}
					});
				}else{
					this.request({
					url: this.auditType == 'pass' ? '/product/audit' : '/product/raise/price',
					data: {
						product_id: this._auditProductId,
						audit_type: 1,
						product_sku_price_list: this._platformProfitModel == 2 ? Array.from(this.$refs.auditTableSupplier.getRow(), item => {
							return {
							  product_sku: item.data.product_sku,
							  product_raise_price: parseFloat(item.data.product_raise_price) || 0
							}
						}) : [],
						product_custom_list: this.isCustom == 1 ? Array.from(this.$refs.customTable.getRow(), item => {
							item.data.custom_raise_price = parseFloat(item.data.custom_raise_price) || 0
							return item.data;
						}) : []
					},
					loading: true,
					success: data => {
						this.$message({
							text: this.auditType == 'pass' ? '审核成功' : '调整成功'
						});
						this.$refs.table.update();
						this.$refs.productAuditMerchant.close();
						this.$refs.productAuditSupplier.close();
					}
				});
			}

        // stop();
        // if(this.auditType != 0) {
        //   var rule = {};
        //   if(this.auditType == 1){
        //     rule.product_price_rate = "请填写平台供应价加价比例";
        //     rule.product_price = "请填写平台供应价";
        //   }else{
        //     rule.reject_reason = "请填写驳回原因"
        //   }
        //   this.$refs.form.submit({
        //     url: '/product/audit',
        //     rule: rule,
        //     dataFormatter: data => {
        //       return Object.assign(data, {
        //         product_id: this.productDetail.product_id,
        //         audit_type: this.auditType
        //       });
        //     },
        //     success: (data, res) => {
        //       this.$message({
        //         text: '审批成功'
        //       });
        //       this.$refs.table.update();
        //       this.$refs.productDetail.close();
        //     }
        //   });
        // }
		},
		//批量审核弹框
		batchAudit(){
			this._auditProductIds = [];
			//批量操作
			var list = this.$refs.table.getRow('selected');
			if (!list.length) {
				this.$message({
					text: '请选择要审批的商品'
				});
				return;
			}
			var flag = true;
			list.forEach(function(item, index, array) {
				if(item.data.state != 3){
					flag = false;
				}
			});
			
			if(!flag){
				this.$message({
					text: '只能选择待审核的商品进行审核！'
				});
				return false;
			}
			
			this._auditProductIds = Array.from(list,item=>{
				return item.data.product_id;
			})
			
			this.$refs.batchAuditForm.clear();
			this.$refs.batchAuditForm.set({state:1});
			this.$refs.batchAuditDialog.open();
		},
		//批量审核提交
		batchAuditHandle(stop){
			stop();
			this.$refs.batchAuditForm.submit({
				url: '/product/batchAudit',
				rule: {
					add_product_ratio: [{
						type: 'empty',
						skip: () => {
							return this.auditState == 2;
						},
						word: '请填写商品加价比例'
					}],
					add_custom_money: [{
						type: 'empty',
						skip: () => {
							return this.auditState == 2;
						},
						word: '请填写定制加价金额(单项)'
					}],
					reject_reason: [{
						type: 'empty',
						skip: () => {
							return this.auditState == 1;
						},
						word: '请填写驳回原因'
					}],
					
				},
				dataFormatter: data => {
					return Object.assign(data, {
						product_ids: this._auditProductIds,
						audit_type: this.auditState
					});
				},
				success: (data, res) => {
					if(this.auditState == 1){
						this.$message({
							icon: 'success',
							text: '审核成功'
						});
					}else{
						this.$message({
							icon: 'success',
							text: '驳回成功'
						});
					}
					this.$refs.table.update();
					this.$refs.batchAuditDialog.close();
				}
			});
		}
    }
	}
</script>

<style lang="stylus" scoped>
	.classify-select {
		padding: 10px;
		
		dl {
			width: 240px;
			border: 1px solid #ddd;
			
			&:nth-child(n+2) {
				border-left: none;
			}
			
			dt {
				position: relative;
				padding: 10px;
			
				.tf {
					position: absolute;
					width: 30px;
					line-height: 36px;
					font-size: 14px;
					text-align: center;
					color: #bbb;
				}
				
				input {
					box-sizing: border-box;
					width: 100%;
					height: 36px;
					border: none;
					padding: 0 10px 0 30px;
					background: #F5F5F5;
				}
			}
			
			dd {
				height: 290px;
				overflow: auto;
				
				li {
					padding: 0 14px;
					line-height: 36px;
					font-size: 13px;
					cursor: pointer;
					
					&:hover,
					&.z-crt {
						background: #FFF17E;
					}
				}
			}
		}
	}
	
	.tag {
		&-list {
			padding: 20px 20px 20px 10px;
		}
		
		&-item {
			margin-left: 10px;
		}
		
		&-img {
			height: 20px;
		}
		
		&-text {
			border: 1px solid #000;
			padding: 0 6px;
			line-height: 18px !important;
			font-size: 12px;
			font-weight: normal !important;
			color: #000;
		}
	}
</style>